import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GuestInvoiceRepositoryService extends BaseRepositoryService<
  ModelRegistry['guest-invoice']
> {
  recordName = 'guest-invoice';
  implementMethods = ['createRecord', 'buildChangeset'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/guest-invoice': GuestInvoiceRepositoryService;
  }
}
